"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const findFilterByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findFilterByKey"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey/QueryFieldKey"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry/QueryFieldRegistry"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const Flag_1 = require("@opsbase/lib-issue/Flag/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const OperatorType_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowCondition/OperatorType"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip"));
const useCss_1 = __importDefault(require("@opsbase/web-css/useCss/useCss"));
const PickEntity_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickEntity"));
const PickSPT_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickSPT"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const DatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Rating_1 = require("@opsbase/web-ui/Rating");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        borderLeft: '5px solid white',
        '&:hover': {
            borderColor: lib_palette_1.default.secondary.main,
        },
    },
});
function AnswerOptionsPicker(props) {
    var _a, _b;
    const { type, rule, handleToggleChangeAnswer, queryField, value, filters, operator, getChangeHandler, } = props;
    let answerOptions = [];
    const myCss = (0, useCss_1.default)(makeMyClasses);
    const inputProps = (0, react_1.useMemo)(() => ({
        style: {
            width: 80,
        },
    }), []);
    const InputProps = (0, react_1.useMemo)(() => ({
        style: {
            width: 90,
            padding: '4px !important',
        },
    }), []);
    switch (type) {
        case FormQuestionType_1.default.CHECK:
            answerOptions = [
                {
                    id: rule['yes'].value,
                    title: rule['yes'].label,
                    color: (0, Flag_1.flagColor)(rule['yes'].flag),
                },
                {
                    id: rule['no'].value,
                    title: rule['no'].label,
                    color: (0, Flag_1.flagColor)(rule['no'].flag),
                },
            ];
            break;
        case FormQuestionType_1.default.RATING:
            answerOptions = [
                {
                    id: rule['rating0'].value,
                    title: rule['rating0'].label,
                    color: (0, Flag_1.flagColor)(rule['rating0'].flag),
                },
                {
                    id: rule['rating1'].value,
                    title: rule['rating1'].label,
                    color: (0, Flag_1.flagColor)(rule['rating1'].flag),
                },
                {
                    id: rule['rating2'].value,
                    title: rule['rating2'].label,
                    color: (0, Flag_1.flagColor)(rule['rating2'].flag),
                },
                {
                    id: rule['rating3'].value,
                    title: rule['rating3'].label,
                    color: (0, Flag_1.flagColor)(rule['rating3'].flag),
                },
                {
                    id: rule['rating4'].value,
                    title: rule['rating4'].label,
                    color: (0, Flag_1.flagColor)(rule['rating4'].flag),
                },
            ];
            break;
        case FormQuestionType_1.default.LIST:
            answerOptions = rule === null || rule === void 0 ? void 0 : rule.options.map(o => (Object.assign(Object.assign({}, o), { id: o.value, title: o.label, color: (0, Flag_1.flagColor)(o.flag) })));
            break;
    }
    switch (type) {
        case FormQuestionType_1.default.CHECK:
        case FormQuestionType_1.default.LIST:
            return (react_1.default.createElement(react_1.default.Fragment, null, answerOptions === null || answerOptions === void 0 ? void 0 : answerOptions.map(fieldOption => {
                const isSelected = !!(0, findFilterByKey_1.default)(filters, fieldOption.queryFieldKey, fieldOption.id);
                return (react_1.default.createElement(MenuItem_1.default, { key: fieldOption.id, maxWidth: 240, onClick: () => handleToggleChangeAnswer(fieldOption), classes: { root: myCss.root }, showTick: isSelected },
                    react_1.default.createElement(Chip_1.default, { style: { margin: 1 }, label: fieldOption.title, color: fieldOption.color })));
            })));
        case FormQuestionType_1.default.RATING:
            return (react_1.default.createElement(react_1.default.Fragment, null, answerOptions === null || answerOptions === void 0 ? void 0 : answerOptions.map((fieldOption, i) => {
                const isSelected = !!(0, findFilterByKey_1.default)(filters, fieldOption.queryFieldKey, fieldOption.id);
                return (react_1.default.createElement(MenuItem_1.default, { key: fieldOption.id, maxWidth: 240, onClick: () => handleToggleChangeAnswer(fieldOption), classes: { root: myCss.root }, label: fieldOption.title, showTick: isSelected },
                    react_1.default.createElement(Rating_1.Rating, { value: i, color: fieldOption.color })));
            })));
        case FormQuestionType_1.default.SPT:
            return (react_1.default.createElement(PickSPT_1.default, { queryField: queryField, filters: filters, onSelect: handleToggleChangeAnswer }));
        case FormQuestionType_1.default.ASSET:
            return (react_1.default.createElement(PickEntity_1.default, { queryField: QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET], filters: filters, onSelect: handleToggleChangeAnswer }));
        case FormQuestionType_1.default.DATETIME:
            return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                react_1.default.createElement(DatePicker_1.default, { noMargin: true, white: true, value: (_a = (0, moment_timezone_1.default)(value === null || value === void 0 ? void 0 : value.from)) === null || _a === void 0 ? void 0 : _a.toDate(), onChange: getChangeHandler('from') }),
                operator === OperatorType_1.default.BETWEEN ? (react_1.default.createElement(DatePicker_1.default, { noMargin: true, white: true, value: (_b = (0, moment_timezone_1.default)(value === null || value === void 0 ? void 0 : value.to)) === null || _b === void 0 ? void 0 : _b.toDate(), onChange: getChangeHandler('to') })) : ('')));
        case FormQuestionType_1.default.NUMBER:
            return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { noMargin: true, value: value === null || value === void 0 ? void 0 : value.from, onBlur: getChangeHandler('from'), type: "number", InputProps: InputProps, inputProps: inputProps }),
                operator === OperatorType_1.default.BETWEEN ? (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { noMargin: true, value: value === null || value === void 0 ? void 0 : value.to, onBlur: getChangeHandler('to'), type: "number", InputProps: InputProps, inputProps: inputProps })) : ('')));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
exports.default = AnswerOptionsPicker;
